"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _router = require("next/router");
var _link = _interopRequireDefault(require("next/link"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["as", "href", "prefetch"],
  _excluded2 = ["activeClassName", "className", "innerRef", "naked", "external"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var NextComposed = /*#__PURE__*/_react.default.forwardRef(function NextComposed(props, ref) {
  var {
      as,
      href,
      prefetch
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_link.default, {
    href: href,
    prefetch: prefetch,
    as: as
  }, /*#__PURE__*/_react.default.createElement("a", _extends({
    ref: ref
  }, other)));
});

// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
var BaseLink = props => {
  var classes = (0, _styles.default)(props);
  var router = (0, _router.useRouter)();
  var {
      activeClassName,
      className: classNameProps,
      innerRef,
      naked,
      external
    } = props,
    other = _objectWithoutProperties(props, _excluded2);
  if (typeof window === 'undefined') {
    return null;
  }
  var className = (0, _clsx.default)(classNameProps, router && router.pathname === props.href && activeClassName, external && classes.external);
  if (naked) {
    return /*#__PURE__*/_react.default.createElement(NextComposed, _extends({
      className: className,
      ref: innerRef
    }, other));
  }
  if (external) {
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      className: className,
      ref: innerRef
    }, other));
  }
  return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    component: NextComposed,
    className: className,
    ref: innerRef
  }, other));
};
BaseLink.defaultProps = {
  activeClassName: 'active',
  external: false
};
// const RouterLink = withRouter(BaseLink);
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(BaseLink, _extends({}, props, {
  innerRef: ref
})));